var detector = {
  iqiyi: function iqiyi() {
    return !!navigator.userAgent.match(/iqiyi\s*IqiyiVersion\/([\d.]+)/i);
  },
  zhishi: function zhishi() {
    return !!navigator.userAgent.match(/knowledge\s*KnowledgeVersion\/([\d.]+)/i);
  },
  chrome: function chrome() {
    return !!navigator.userAgent.match(/Chrome\/([\d.]+)/) || !!navigator.userAgent.match(/CriOS\/([\d.]+)/);
  },
  android: function android() {
    return !!navigator.userAgent.match(/(Android);?[\s/]+([\d.]+)?/);
  },
  iOS: function iOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  },
  iOSEgt9: function iOSEgt9() {
    return this.iOS() && /OS (\d+)/i.exec(navigator.userAgent)[1] >= 9;
  },
  iPad: function iPad() {
    return /iPad/.test(navigator.userAgent) && !window.MSStream;
  },
  iPhoneX: function iPhoneX() {
    if (typeof window !== 'undefined') {
      return /iphone/gi.test(navigator.userAgent) && window.screen.height >= 812;
    }
    return false;
  },
  vivo: function vivo() {
    return !!navigator.userAgent.match(/vivo (\w+) /i);
  },
  qq: function qq() {
    return !!navigator.userAgent.match(/(QQBrowser)\/([\d.]+)/);
  },
  uc: function uc() {
    return !!navigator.userAgent.match(/UCBrowser/i);
  },
  baidu: function baidu() {
    return !!navigator.userAgent.match(/baidu/i);
  },
  wechat: function wechat() {
    return /MicroMessenger/.test(navigator.userAgent);
  }
};

export default detector;
